import React from 'react'
import { connect } from 'react-redux';
import {
  Drawer,
  Typography,
  Tag,
  Input,
  Button,
  Select
} from 'antd';
import { localization } from '../../Utils/Localization/localization';
import { languageSelector } from '../../Redux/Reducers/settingsReducer';
import {
  getCategories,
  categoriesSelector
} from '../../Redux/Reducers/categoriesReducer';
import {
  IProductFull,
  ICategory
} from '../../Utils/types';
import {
  currentProductSelector,
  updateProduct,
  applyUpdateProduct,
  getProductInfo,
  updateProductPhoto
} from '../../Redux/Reducers/productsReducer';
import classes from './ProductDrawer.module.scss';
import { UpdatePhoto } from './UpdatePhoto';
import { userLevelSelector } from '../../Redux/Reducers/userReducer';

interface StateProps {
  language: string,
  product: IProductFull,
  categories: ICategory[],
  level: number
}
interface DispatchProps {
  getCategories: () => void,
  getProductInfo: (id: number) => void,
  updateProduct: (name: string, value: any) => void,
  applyUpdateProduct: () => void,
  updateProductPhoto: (file: any, id: number, mod?: boolean) => void
}
interface Props extends StateProps, DispatchProps {
  visible: boolean,
  id: number
  onClose: () => void
}

function ProductDrawer(props: Props) {
  const [tag, setTag] = React.useState('');
  const [uploadPhotoDrawer, setUploadPhotoDrawer] = React.useState(false);
  const permissionLevel = props.level >= 2;

  function handleOnChange(name: string, value: any) {
    props.updateProduct(name, value);
  }

  function applyUpdateProduct() {
    if (permissionLevel) {
      props.applyUpdateProduct();
    }
      props.onClose();
  }

  React.useEffect(() => {
    if (props.id !== 0) {
      props.getProductInfo(props.id);
      props.getCategories();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  function updatePhoto(file: any) {
    props.updateProductPhoto(file.target.files[0], props.id, true);
  }

  return (
    <Drawer
      visible={props.visible}
      onClose={props.onClose}
      width={window.screen.width <= 600 ? '70%' : '35%'}
      title={`${localization('product', props.language)}: ${props.product.id}`}
    >
      {
        props.product
          ? <>
            <div className={classes.ProductDrawer}>
              <UpdatePhoto
                handleSubmit={() => setUploadPhotoDrawer(false)}
                img={props.product.photourl}
                language={props.language}
                updatePhoto={updatePhoto}
                visible={uploadPhotoDrawer}
                handleClose={() => setUploadPhotoDrawer(false)}
              />
              <div className={classes.icon}>
                <img src={props.product.photourl.huge} alt="ProductPhoto" />
                <Button
                  onClick={() => setUploadPhotoDrawer(true)}
                  disabled={!permissionLevel}
                >
                  {localization('uploadPhoto', props.language)}
                </Button>
              </div>
              <div className={classes.info}>
                <span>{localization('name', props.language)}</span>
                <Typography.Paragraph
                  editable={permissionLevel && { onChange: (str) => handleOnChange('name', str) }}
                >
                  {props.product.name || ''}
                </Typography.Paragraph>
              </div>
              <div className={classes.info}>
                <span>{localization('price', props.language)}</span>
                <Input value={props.product.price} onChange={(e: any) => permissionLevel && handleOnChange('price', e.target.value)} />
              </div>
              <div className={classes.Tags}>
                <span className={classes.Span}>{localization('tags', props.language)}</span>
                <div>
                  {
                    props.product.tags &&
                    props.product.tags.map((item: any, index) => {
                      return (
                        <Tag
                          closable={permissionLevel}
                          onClose={() => {
                            let array = [...props.product.tags];
                            array.splice(index, 1);
                            props.updateProduct('tags', array);
                          }}
                          key={item}
                        >
                          {item}
                        </Tag>);
                    })
                  }
                </div>
                <span>{localization('newTag', props.language)}</span>
                <Input
                  placeholder={localization('newTag', props.language)}
                  value={tag}
                  onChange={(e: any) => permissionLevel && setTag(e.target.value)}
                  onPressEnter={() => {
                    if (tag !== '') {
                      const newTagsArray = [...props.product.tags];
                      newTagsArray.push(tag);
                      props.updateProduct('tags', newTagsArray);
                      setTag('');
                    }
                  }}
                />
              </div>
              <div className={classes.info}>
                <span>{localization('category', props.language)}</span>
                <Select
                  style={{ width: '200px', marginBottom: '20px' }}
                  onChange={(e: any) => {
                    permissionLevel && props.updateProduct('categoryId', e);
                  }}
                  value={props.product.categoryId}
                  defaultValue={props.product.categoryId}
                >
                  {
                    props.categories.map((item) => {
                      return (
                        <Select.Option value={item.id} key={item.id}>{item.name}</Select.Option>
                      );
                    })
                  }
                </Select>
              </div>
              <Button
                type={'primary'}
                onClick={applyUpdateProduct}
              >
                {localization('done', props.language)}
              </Button>
            </div>
          </>
          : <span>{localization('wait', props.language)}</span>
      }
    </Drawer>
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state),
    product: currentProductSelector(state),
    categories: categoriesSelector(state),
    level: userLevelSelector(state)
  }
}
const mapDispatchToProps = {
  getProductInfo,
  updateProduct,
  applyUpdateProduct,
  getCategories,
  updateProductPhoto
}

const ConnectedProductDrawer = connect(mapStateToProps, mapDispatchToProps)(ProductDrawer);
export { ConnectedProductDrawer as ProductDrawer };